import { render } from "./AsBannerSquare.vue?vue&type=template&id=d7d08330&scoped=true&ts=true"
import script from "./AsBannerSquare.vue?vue&type=script&lang=ts"
export * from "./AsBannerSquare.vue?vue&type=script&lang=ts"

import "./AsBannerSquare.vue?vue&type=style&index=0&id=d7d08330&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d08330"]])

export default __exports__